import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Subject } from 'rxjs';

import { REGULAR_EXPRESSION_CONSTANTS, SNACKBAR_CONSTANTS } from '../../shared/constants';
import { ContactSupportDataService } from '../data-services/contact-support-data.service';
import { ContactSupportRequest } from './models/contactSupportRequest';

@Injectable({
    providedIn: 'root'
})
export class ContactSupportLogicService {
    private _isSupportSubmitted: Subject<boolean> = new Subject<boolean>();

    isSupportSubmitted$ = this._isSupportSubmitted.asObservable();

    constructor(
        private _contactSupportDataService: ContactSupportDataService, private _snackBar: MatSnackBar
    ) { }

    createFormGroup(): UntypedFormGroup {
        return new UntypedFormGroup({
            firstName: new UntypedFormControl(null, [Validators.required]),
            lastName: new UntypedFormControl(null, [Validators.required]),
            workEmail: new UntypedFormControl(null, [Validators.required, Validators.pattern(REGULAR_EXPRESSION_CONSTANTS.emailPattern)]),
            message: new UntypedFormControl(null, [Validators.required]),
        });
    }

    submitContactForm(contactForm: UntypedFormGroup): void {
        const contactSupportRequest: ContactSupportRequest = {
            firstName: contactForm.value.firstName,
            lastName: contactForm.value.lastName,
            workEmail: contactForm.value.workEmail,
            message: contactForm.value.message,
        };

        this._contactSupportDataService.submitContactForm(contactSupportRequest)
            .subscribe({
                next: (response: boolean) => {
                    this._isSupportSubmitted.next(response);
                },
                error: () => {
                    this._snackBar.open(SNACKBAR_CONSTANTS.CONTACT_SUPPORT_ERROR, 'Close', { duration: 3000 });
                    this._isSupportSubmitted.next(false);
                }
            });
    }
}
